if($('.entry-comments').length > 0) {
    // Global variables needed by Disqus. The identifier and url should be different for each comment thread.
    var disqus_shortname = 'arabnewscom';
    var dsq;

// Loads the Disqus JS file that will create the comment form and threads.
    dsq = document.createElement('script');
    dsq.type = 'text/javascript';
    dsq.async = true;
    dsq.src = 'https://' + disqus_shortname + '.disqus.com/embed.js';
    $('head').append(dsq);
}

// Called in each location you want to show the thread.

// Disqus searches for 'disqus-thread' elements and uses the first one it finds so to
// overcome this, the function will clear any previous comment threads (by finding 'comments-load' elements)
//

window.loadDisqus = function (element, postTitle, postUrlTag) {
    var identifier = postTitle;
    // Including the hashbang ('/#!') is important.
    var url = window.location.origin + '/#!' + postUrlTag;

    var commentsHolder = $(element).closest('.entry-comments').find('.entry-comments-inner');
    var txt = $(element).find('span').text();

    /*setTimeout(function(){
        $('html, body').animate({
            scrollTop: $(element).offset().top
        }, 1000);
    }, 500);*/

    if (window.DISQUS && commentsHolder.children('#disqus_thread').length == 0) {
        $(".comments-load").each(function () {
            $('.entry-comments .entry-comments-inner').empty();
            $(this).find('i').removeClass('icon-plus-circle').addClass('icon-minus-circle');
            $(this).find('span').text("Show comments");
            $(this).removeClass('comments-holder-opened');
        });

        commentsHolder.append('<div class="disqus-thread" id="disqus_thread"></div>');
        $(element).find('i').removeClass('icon-minus-circle').addClass('icon-plus-circle');
        $(element).find('span').text("Masquer les commentaires");
        $(element).addClass('comments-holder-opened');
        $(document).scrollTop(commentsHolder.offset().top - 200);

        /** if Disqus exists, call it's reset method with new parameters **/
        DISQUS.reset({
            reload: true,
            config: function () {
                //important to convert it to string
                this.page.identifier = identifier.toString();
                this.page.url = url;
            }
        });
    } else if (window.DISQUS && commentsHolder.children('#disqus_thread').length == 1) {
        $(element).find('.top-icon i').toggleClass('icon-plus-circle icon-minus-circle');
        $(element).find('span').text(txt == "اضافة تعليق جديد" ? "Hide Comments" : "اضافة تعليق جديد");
        $(element).toggleClass('comments-holder-opened');
        commentsHolder.slideToggle();
    }
};
